import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Tooltip, IconButton, Dialog } from '@material-ui/core'
import AssignmentIcon from '@material-ui/icons/Assignment'
import { openDialogDetalles, saveDetallePdf } from '../actions'
import DialogView from '../../Dialogos/DialogView'
import DetalleListadoRepresentantesDialog from '../containers/DetalleListadoRepresentantesDialog'
import DescargaPdf from '../../PdfDownload/container/DescargaPdf'

function OperacionesListadoRepresentantes (props) {
  const { detalle } = props
  const [openDetalle, setOpenDetalle] = useState(false)

  const urlPdf = `${process.env.REACT_APP_PDF_URL}${detalle.numero}.pdf`

  const handleClose = () => {
    setOpenDetalle(false)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <Dialog
        open={openDetalle}
        onClose={handleClose}
        maxWidth='lg'
      >
        <DialogView
          show={openDetalle}
          cancelCallback={handleClose}
          showPrint
          title={`Detalle de carta de porte electrónica CTG ${detalle.numero}`}
          content={<DetalleListadoRepresentantesDialog detalle={detalle} />}
        />
      </Dialog>

      <Tooltip title={'Ver detalle'}>
        <IconButton onClick={() => setOpenDetalle(true)}>
          <AssignmentIcon fontSize='default' color='primary' />
        </IconButton>
      </Tooltip>

      <Tooltip title={'Descargar PDF desde ARCA'}>
        <DescargaPdf url={urlPdf} filename={detalle.numero} />
      </Tooltip>
    </div>

  )
}

const mapActionsToProps = {
  openDialogDetalles,
  saveDetallePdf
}

export default connect(null, mapActionsToProps)(OperacionesListadoRepresentantes)
